/* Header behaviour: dropdowns, search panel, mobile drawer, predictive search. */
(function () {
  'use strict';

  var Sloos = window.Sloos || {};

  /* ---------------- Desktop dropdowns ---------------- */

  function initDropdowns() {
    document.querySelectorAll('[data-dropdown]').forEach(function (item) {
      if (item.dataset.ready === 'true') return;
      item.dataset.ready = 'true';

      var trigger = item.querySelector('.header__nav-link');
      var panel = item.querySelector('[data-dropdown-panel]');
      if (!trigger || !panel) return;

      var timer;

      function open() {
        clearTimeout(timer);
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(close, 120);
      });
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close();
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });
  }

  /* ---------------- Search panel ---------------- */

  function initSearch() {
    var panel = document.getElementById('HeaderSearch');
    if (!panel) return;

    var input = panel.querySelector('[data-predictive-input]');

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-search-toggle]');
      if (!toggle) return;
      event.preventDefault();

      var open = panel.hidden;
      panel.hidden = !open;

      document.querySelectorAll('[data-search-toggle][aria-controls="HeaderSearch"]').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      if (open && input) input.focus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        var toggle = document.querySelector('[data-search-toggle][aria-controls="HeaderSearch"]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      }
    });
  }

  /* ---------------- Predictive search ---------------- */

  function initPredictive() {
    var root = document.querySelector('[data-predictive-search]');
    if (!root) return;

    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var controller;

    var run = (Sloos.debounce || function (fn) { return fn; })(function () {
      var term = input.value.trim();

      if (term.length < 2) {
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        (Sloos.routes && Sloos.routes.predictiveSearch ? Sloos.routes.predictiveSearch : '/search/suggest') +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search unavailable');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fragment = doc.querySelector('#PredictiveSearchResults');
          results.innerHTML = fragment ? fragment.innerHTML : '';
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          results.innerHTML = '';
        });
    }, 250);

    input.addEventListener('input', run);
  }

  /* ---------------- Mobile drawer ---------------- */

  function initMobileNav() {
    var drawer = document.getElementById('MobileNav');
    if (!drawer) return;

    var release = null;

    function open(trigger) {
      drawer.hidden = false;
      if (Sloos.lockScroll) Sloos.lockScroll();
      if (Sloos.trapFocus) release = Sloos.trapFocus(drawer, trigger);
      document.querySelectorAll('[data-mobile-nav-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
    }

    function close() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      if (Sloos.unlockScroll) Sloos.unlockScroll();
      if (release) {
        release();
        release = null;
      }
      document.querySelectorAll('[data-mobile-nav-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mobile-nav-open]')) {
        event.preventDefault();
        open(event.target.closest('[data-mobile-nav-open]'));
      } else if (event.target.closest('[data-mobile-nav-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    /* A tap on a real link should navigate and leave the drawer closed. */
    drawer.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link && !link.closest('.mobile-nav__details > summary')) close();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 860) close();
    });
  }

  function init() {
    initDropdowns();
    initSearch();
    initPredictive();
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
